import * as React from "react";
function SvgUserQuote(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M3.46 4l.67.53A2.66 2.66 0 003 6.18a1.63 1.63 0 01.23 0 .87.87 0 01.88.9 1 1 0 01-1 1C2.52 8 2 7.52 2 6.66A3.33 3.33 0 013.46 4zm2.87 0l.67.53a2.66 2.66 0 00-1.15 1.65h.23A.87.87 0 017 7a1 1 0 01-1 1c-.6 0-1.12-.48-1.12-1.34A3.33 3.33 0 016.33 4zM30 6.66C30 7.52 29.48 8 28.88 8a1 1 0 01-1-1 .87.87 0 01.88-.9 1.63 1.63 0 01.23 0 2.66 2.66 0 00-1.15-1.65l.7-.45A3.33 3.33 0 0130 6.66zm-2.88 0C27.12 7.52 26.6 8 26 8a1 1 0 01-1-1 .87.87 0 01.88-.9h.23A2.66 2.66 0 0025 4.53l.67-.53a3.33 3.33 0 011.45 2.66z" />
      <circle
        cx={16}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M11.11 29H5a11 11 0 0122 0h-6.11"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserQuote);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
